<template>
    <div id="cookie-policy" v-if="showCookiePolicy">
        <div class="container-xl">
            <div class="row">
                <div class="col-12 col-md-9">
                    <div>{{lang('cookie_szoveg')}}</div>                                     
                    <router-link v-if="currentLangName() == 'hu'" :to="{path: '/hu/informacio/adatvedelmi_nyilatkozat' }" class="text-link">
                        {{ lang('hirlevel_adatvedelmi_tajekoztato')}}
                    </router-link>
                    <router-link v-else-if="currentLangName() == 'en'" :to="{path: '/en/information/privacy-policy' }" class="text-link">
                        {{ lang('hirlevel_adatvedelmi_tajekoztato')}}
                    </router-link>
                    <router-link v-else-if="currentLangName() == 'ru'" :to="{path: '/ru/informacio/terms-of-use' }" class="text-link">
                        {{ lang('hirlevel_adatvedelmi_tajekoztato')}}
                    </router-link>
                </div>
                <div class="col-12 col-md-3 btn-wrap">
                    <button class="btn btn--green-border" @click="acceptCookies">{{ lang('elfogadom')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return{
            showCookiePolicy: true,            
        }
    },
    methods:{
        acceptCookies(){
            this.$cookies.set('cookiePolicyU', 1, 'session');
            this.setGTMScriptTag()
            this.showCookiePolicy = false
        },
        setGTMScriptTag(){
            //add GTM script
            let gtmScriptHeadPlace = window.document.getElementsByTagName('head')[0]            
            let gtmScript = window.document.createElement('script')
            if (window.location.hostname == 'localhost'){
                gtmScript.innerHTML = "console.log('gtm script place')"
            } else {
                gtmScript.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': \n" +
                "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], \n" + 
                "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= \n" +
                "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); \n" +
                "})(window,document,'script','dataLayer','GTM-52VZBXV');";
            }           
            
            gtmScriptHeadPlace.appendChild(gtmScript);  

            //noscript tag
            let gtmScriptBodyPlace = window.document.getElementsByTagName('body')[0]            
            let gtmScriptNoScript = window.document.createElement('noscript')            
            if (window.location.hostname == 'localhost') {
                gtmScriptNoScript.innerHTML = "console.log('gtm script noscript place')";
            } else {
                gtmScriptNoScript.innerHTML = "<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-52VZBXV\" \n" +
                "height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>"
            }
           
            gtmScriptBodyPlace.insertBefore(gtmScriptNoScript, gtmScriptBodyPlace.childNodes[0]);  
        }        
    },
    created(){        

        let acceptCookiePolicy = this.$cookies.get('cookiePolicyU');                 

        if ( parseInt(acceptCookiePolicy) === 1){
            this.showCookiePolicy = false     
            this.setGTMScriptTag()       
        }
    }
}
</script>